import { render, staticRenderFns } from "./TrainingCourse.vue?vue&type=template&id=91a3d97a"
import script from "./TrainingCourse.vue?vue&type=script&lang=js"
export * from "./TrainingCourse.vue?vue&type=script&lang=js"
import style0 from "./TrainingCourse.vue?vue&type=style&index=0&id=91a3d97a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports